import NiceModal from "@ebay/nice-modal-react"
import { Import, Loader2 } from "lucide-react"
import { useState } from "react"

export function DiscoveryButton(): JSX.Element {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)
    const open = async () => {
        if (loading) return
        setLoading(true)
        setError(null)
        try {
            const { DiscoveryModal } = await import("./DiscoveryModal")
            void NiceModal.show(DiscoveryModal)
        } catch (error) {
            setError(error instanceof Error ? error.message : String(error))
        } finally {
            setLoading(false)
        }
    }
    return (
        <div>
            <button
                type="button"
                className="btn flex min-h-9 w-full items-center gap-2 px-3 text-left text-xs text-muted hover:bg-base-300 hover:text-base-content max-[900px]:min-h-11"
                disabled={loading}
                onClick={() => void open()}
            >
                {loading ? <Loader2 size={14} className="shrink-0 animate-spin" /> : <Import size={14} className="shrink-0" />}
                <span className="truncate">Import conversations</span>
            </button>
            {error && (
                <p role="alert" className="px-3 text-xs text-error">
                    {error}
                </p>
            )}
        </div>
    )
}
